import React from 'react';
function Filter({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 4H3l7.2 8.409v5.813L13.8 20v-7.591L21 4z"
      />
    </svg>
  );
}

export default Filter;
